import { ricsAndCompanyBranchLabels } from '../constants/branch-labels';
import { passThroughEffectiveFilter } from '../engine/default-handlers';
import { defineTreeFilter } from '../engine/descriptor';
import { FilterId, FilterType } from '../types/filters';

export const founderPreviousCompanyDescriptor = defineTreeFilter({
  definition: {
    id: FilterId.FOUNDER_COMPANY,
    name: 'Founder Previous Company',
    selections: [],
    type: FilterType.TREE,
    selectionListIds: ['rics_k10', 'rics_k400', 'company'],
    branches: ricsAndCompanyBranchLabels,
    isVisible: true,
  },
  handler: { getEffectiveFilter: passThroughEffectiveFilter },
});
